import { render, staticRenderFns } from "./LoadPageLayout.vue?vue&type=template&id=61b08b1c&"
import script from "./LoadPageLayout.vue?vue&type=script&lang=js&"
export * from "./LoadPageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports